<template>
    <div style="height:100%;">
        <div style="padding:20px;display:flex; flex-direction: column;height:100%;">
            <div style=" font-size:20px; font-weight:bold;">프리랜서 용역계약서 수정</div>
            <div style=" margin-top:20px;flex:1;overflow:hidden;" ref="editor_wrapper">
                <ckeditor v-model="editorData" :config="editorConfig" ref="test" style="" @ready="onEditorReady"></ckeditor>
            </div>
            <div style="width:100%; display:flex; flex-direction: row-reverse;">
                <div class="btn" style="" @click="save">저 장</div>
            </div>
            <div style="height:5px;"></div>
            <!--<button @click="getHtml">얻기html</button>-->
        </div>
    </div>
</template>

<script>
    import ResponseCode from "../../ResponseCode";

    export default {
        name: "ContractEditor",
        data(){
            return {
                editorData: '',
                editorConfig: {
                    extraPlugins: ['font'],
                    allowedContent : true,
                    toolbar: [
                        { name: 'styles', items: ['Format', 'Font', 'FontSize'] }, //extraPlugins에 fon가 있어야 나옴
                        { name: 'document', items: ['Source', '-', 'NewPage', 'Preview', '-', 'Templates'] },
                        { name: 'clipboard', items: ['Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo'] },
                        { name: 'editing', items: ['Find', 'Replace', '-', 'SelectAll', '-', 'Scayt'] },
                        '/',
                        { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-', 'RemoveFormat'] },
                        { name: 'paragraph', items: ['NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'Blockquote', 'CreateDiv', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-', 'BidiLtr', 'BidiRtl'] },
                        { name: 'links', items: ['Link', 'Unlink', 'Anchor'] },
                        { name: 'insert', items: ['Image', 'Flash', 'Table', 'HorizontalRule', 'Smiley', 'SpecialChar', 'PageBreak', 'Iframe'] },
                        '/',
                        { name: 'colors', items: ['TextColor', 'BGColor'] },
                        { name: 'tools', items: ['Maximize', 'ShowBlocks'] },
                        { name: 'others', items: ['-'] },
                        { name: 'about', items: ['About'] }
                    ],
                },
                editorInstance : null
            }
        },
        methods : {
            onEditorReady(editor) {
                this.editorInstance = editor;
                this.resizeEditor();
                window.addEventListener('resize', this.resizeEditor);
            },
            resizeEditor() {
                if (this.editorInstance && this.$refs.editor_wrapper) {
                    const parentHeight = this.$refs.editor_wrapper.offsetHeight;
                    this.editorInstance.resize('100%', parentHeight);
                }
            },
            async save(){
                if(this.editorData === ''){
                    this.$GlobalStore.showAlert('계약서 내용을 입력해주세요.');
                    return;
                }

                const parameters = {};
                parameters.contract_text = this.editorData;
                parameters.auth = this.$route.query.auth;
                const res = await this.$Axios.post('/api/contract/text/save', parameters);
                if(res.data.code === ResponseCode.SUCCESS){
                    this.$GlobalStore.showAlert('저장하였습니다.');
                }else if(res.data.code === ResponseCode.FAIL){
                    this.$GlobalStore.showAlert(res.data.msg);
                }
            },
            async getContractStr(){
                const parameters = {};
                const res = await this.$Axios.get('/api/contract/text', {params : parameters});
                this.editorData =  res.data.contract_text;
            }
        },
        beforeDestroy() {
            // Clean up the event listener
            window.removeEventListener('resize', this.resizeEditor);
        },
        created(){
            if(this.$hasOwnProperty(this.$route.query, 'auth') && this.$route.query.auth){
                this.getContractStr();
            }

            this.save = this.$Once(this.save);
        }
    }
</script>
<style scoped>
    .btn{cursor:pointer; padding:5px 20px; font-size:20px; font-weight:bold; background-color: var(--color-main); color: white; border-radius:8px; margin-top:10px; margin-right:10px;}
    .btn:hover{background-color: green;}
</style>
<style>
    .cke_notification.cke_notification_warning { display: none; }
</style>